import React, { useEffect, useState } from 'react'
import Topbar from '../components/Topbar'
import Leftbar from '../components/Leftbar'
import { Link } from 'react-router-dom'
import {
  getPhyioKyc,
  displayError,
  displaySuccess,
  getNriInterest,
  getNriDetails,
  getProviderByInterest,
  getCouponList,
  getNriBookingById,
  removeSlots
} from '../Utils/utils'
import axios from 'axios'
import config from '../config/config'
import { connect } from 'react-redux'
import { toggleLoader } from '../actions/loader'
import TimePicker from 'react-time-picker'
import './style.css'
import DatePicker from 'react-datepicker'
import moment from 'moment'

const ChangeProvider = props => {
  const queryParams = new URLSearchParams(window.location.search)
  const bookingId = queryParams.get('id')
  const interestId = queryParams.get('interest_id')
  const edit = queryParams.get('edit')
  const change = queryParams.get('change')
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPass, setNewPass] = useState('')
  const [confirmPass, setConfirmPass] = useState('')
  const [providers, setProviders] = useState([])
  const [providerId, setProviderId] = useState('')
  const [amount, setAmount] = useState('')
  const [couponArr, setCouponArr] = useState([])
  const [couponId, setCouponId] = useState('')
  const [fromDate, setFromDate] = useState(new Date())
  const [fromTime, setFromTime] = useState(moment(new Date()).format('HH:mm'))
  const [toTime, setToTime] = useState(moment(new Date()).format('HH:mm'))
  const [slotArr, setSlotArr] = useState([])
  const [newSlots, setNewSlots] = useState([])

  console.log(bookingId, providerId)
 
  const getProviders = async () => {
    var res = await getProviderByInterest(interestId)
    setProviders(res)
  }

 
  useEffect(() => {
    if (interestId != undefined) {
      getProviders()
    }
  }, [interestId])



  const getBookingDetail = async () => {
    var res = await getNriBookingById(bookingId)
    setProviderId(res.data?.provider_id)

  }
  useEffect(() => {
      getBookingDetail()
  }, [])

  

  
  const ChangeProvider = async () => {
    props.toggleLoader(true)
    let path = config.siteUrl
    path = path + '/nri/change-booking-provider'
    var token = localStorage.getItem('token')
    var data = {}
    data = {
      booking_id: bookingId,
      provider_id: providerId
    }
    axios
      .post(path, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(function (response) {
        props.toggleLoader(false)
        console.log(response, '-ppplp')
        displaySuccess(response?.data?.message)
        setTimeout(() => (window.location.href = '/nri-bookings'), 3000)
      })
      .catch(function (error) {
        props.toggleLoader(false)
        displayError(error)
      })
  }


  return (
    <>
      <body class='g-sidenav-show  bg-gray-100'>
        <div id='wrapper'>
          <Leftbar />
          <main className='main-content border-radius-lg'>
            <Topbar />
            <div>
              <div className='header bg-primary pb-6'>
                <div className='container-fluid'>
                  <div className='header-body'>
                    <div className='row align-items-center py-4'>
                      <div className='col-lg-6 col-7'>
                        <nav
                          aria-label='breadcrumb'
                          className='d-none d-md-inline-block ml-md-4'
                        >
                          <ol className='breadcrumb breadcrumb-links breadcrumb-dark'>
                            <li className='breadcrumb-item'>
                              <Link to='/dashboard-nri'>
                                <i className='fas fa-home' />
                              </Link>
                            </li>
                            <li className='breadcrumb-item'>
                              <Link to='/nri-bookings'>Bookings </Link>
                            </li>
                            <li className='breadcrumb-item'>
                              <Link to='/update-password'>Change Provider</Link>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='container-fluid mt--6'>
                <div className='row'>
                  <div className='col'>
                    <div className='card mb-4'>
                      <div className='card-header'>
                        <h3 className='mb-0'>Change Provider</h3>
                      </div>
                      <div className='card-body'>
                        <div className='row'>
                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label className='form-control-label'>
                                Provider
                              </label>
                              <select
                                className='form-select select-dropdown'
                                aria-label='Default select example'
                                value={providerId}
                                onChange={e => setProviderId(e.target.value)}
                              >
                                <option value='' selected>
                                  Select Provider
                                </option>
                                {providers &&
                                  providers?.map(item => {
                                    return (
                                      <option value={item?._id}>
                                        {item?.name}{' '}
                                        {item?.interest
                                          ? `(${item?.interest?.name})`
                                          : null}
                                      </option>
                                    )
                                  })}
                              </select>
                            </div>
                          </div>
                          
                         
                        </div>
                       
                        

                        
                        <button
                          className='btn btn-primary mt-4'
                          onClick={() => {
                            ChangeProvider()
                          }}
                        >
                          {' '}
                          <i className='far fa-paper-plane' /> Submit{' '}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = state => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangeProvider)
